import { Map } from 'immutable'

export const SET_SPOTLIGHT_HERO = 'SPOTLIGHT_HERO_SET'
export const CLEAR_SPOTLIGHT_HERO = 'SPOTLIGHT_HERO_CLEAR'

export function setSpotlightHero (payload) {
  return { type: SET_SPOTLIGHT_HERO, payload }
}

export function clearSpotlightHero () {
  return { type: CLEAR_SPOTLIGHT_HERO }
}

export const initialState = Map()

export default function spotlightHeroReducer (state = initialState, action) {
  switch (action.type) {
    case SET_SPOTLIGHT_HERO:
      return Map.isMap(action.payload) ? action.payload : Map(action.payload)
    case CLEAR_SPOTLIGHT_HERO:
      return initialState
    default:
      return state
  }
}
